<template>
  <v-container>
    <v-container class="ma-0 pa-0 pb-5 d-flex" style="align-items: center; flex-wrap:wrap;">
      <h1>Конструктор сметы</h1>
      <v-spacer v-if="!$vuetify.breakpoint.smAndDown"></v-spacer>
      <v-dialog 
        max-width="350" 
        v-model="confirmReload"
      >
        <template v-slot:activator="{ on }">
          <v-btn color="red" outlined v-on="on">
            <v-icon left>mdi-reload</v-icon>
            Начать заново
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="headline">Уверены?</v-card-title>
          
          <v-card-text>
            Все данные текущего расчета будут уничтожены!
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn 
              color="blue darken-1" 
              text 
              @click="confirmReload = false;"
            >Отмена</v-btn>

            <v-btn
              color="blue darken-1"
              text
              @click="reload(); confirmReload = false;"
            >ОК</v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>
      
    </v-container>

    <v-stepper v-model="curStep" :key="calcId">
      <v-stepper-header>
        <v-stepper-step
          :complete="curStep > 1"
          step="1"
        >
          Параметры объекта
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="curStep > 2"
          step="2"
          :objParams="calc.object"
        >
          Работы
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step 
          :complete="curStep > 3"
          step="3"
        >
          Чистовые материалы
        </v-stepper-step>
        
        <v-divider></v-divider>

        <v-stepper-step step="4">
          Готовая смета
        </v-stepper-step>
      </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <object-step
          @save="nextStep($event)"
        ></object-step>
      </v-stepper-content>

      <v-stepper-content step="2">
        <services-step
          v-if="curPrice && curStep > 1"
          @save="nextStep($event)"
          @cancel="prevStep()"
          :objParams="calc.objectEntity"
          :price="curPrice"
        ></services-step>
      </v-stepper-content>

      <v-stepper-content step="3">
       <materials-step
          v-if="curPrice && curStep > 2"
          @save="nextStep($event)"
          @cancel="prevStep()"
          :services="calc.services"
          :price="curPrice"
       ></materials-step>
      </v-stepper-content>

      <v-stepper-content step="4">
       <finish-step
        :id="estimateId"
        @reload="reload()"
       ></finish-step>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>

  </v-container>
</template>

<script>
import FinishComponent from './FinishStep';
import ObjectComponent from './ObjectStep';
import ServicesComponent from './ServicesStep';
import MaterialsComponent from './MaterialsStep';

export default {
  name: 'estimate-constructor',

  props: {
    curPrice: Object,
    storeSaveFunc: String,
    ownerId: String,
  },

  components: {
    'finish-step': FinishComponent,
    'object-step': ObjectComponent,
    'services-step': ServicesComponent,
    'materials-step': MaterialsComponent
  },

  data() {
    return {
      calcId: this.getTempId(),
      estimateId: null,
      confirmReload: false,
      curStep: 1,
      calc: {
        owner: this.ownerId,
        objectEntity: null,
        services: null,
        materials: null
      }
    }
  },

  created() {
    document.title = 'Конструктор сметы';
  },

  methods: {
    nextStep(data) {
      if (this.curStep == 1) this.calc.objectEntity = data;
      if (this.curStep == 2) this.calc.services = data;
      if (this.curStep == 3) this.calc.materials = data;
      this.curStep++;
      if (this.curStep == 4) {
        // Сохраняем смету на сервере
        console.log(this.calc);
        this.$store.dispatch(this.storeSaveFunc, this.calc).then(id => this.estimateId = id);
      }
    },
    prevStep() {
      if (this.curStep == 2) this.calc.services = null;
      if (this.curStep == 3) this.calc.materials = null;
      this.curStep--;
    },
    reload() {
      this.calc = {
        object: null,
        services: null,
        materials: null
      };
      this.estimateId = null;
      this.curStep = 1;
      this.calcId = this.getTempId();
    },
  },
}
</script>